module.exports = __webpack_public_path__ + "img/Weapon_150.0d3ffdf4.png";